// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fcbee214","891":"d2221e04","919":"d928448b"}[chunkId] + ".chunk.js";
};